import type { ShortAnswerToolSettingsProps } from './tool-defaults';
import { DEFAULT_SHORT_ANSWER_TOOL_LABEL } from './tool-defaults';
import { SHORT_ANSWER_TOOL_SETTINGS_BY_LABEL } from './tool-registry';

export type ShortAnswerToolSettingsWrapperProps = ShortAnswerToolSettingsProps & {
    toolLabel: string;
    disabled?: boolean;
};

export function ShortAnswerToolSettingsWrapper({ toolLabel, builderProps, onPatch, disabled }: ShortAnswerToolSettingsWrapperProps) {
    const Comp = SHORT_ANSWER_TOOL_SETTINGS_BY_LABEL[toolLabel] ?? SHORT_ANSWER_TOOL_SETTINGS_BY_LABEL[DEFAULT_SHORT_ANSWER_TOOL_LABEL];
    return (
        <fieldset
            disabled={disabled}
            className="m-0 min-w-0 border-0 p-0"
        >
            <Comp
                builderProps={builderProps}
                onPatch={onPatch}
            />
        </fieldset>
    );
}
